import { boot } from 'quasar/wrappers'
export default boot(({ app }) =>  {
    const isNumeric = (str) => {
        if (typeof str != "string") return false; // we only process strings!
        return (
            !isNaN(str) && !isNaN(parseFloat(str)) // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
        ); // ...and ensure strings of whitespace fail
    }
    const phoneNumber = (phoneNumber) => {
        if(`${phoneNumber}`.trim().length == 0){
            return true;
        }
        if (`${phoneNumber}`.length > 18) {
            return false;
        }
        let regEx = /^\+{0,2}([\-\. ])?()?([\-\. ])??([\-\. ])?\d{3}([\-\. ])?\d{4}/;
        if (`${phoneNumber}`.match(regEx)) {
            return true;
        } else {
            return false;
        }
    }
    const email = (email) => {
        if(`${email}`.trim().length == 0) return true;
        return email.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) ? true : false;
    }
    const equal = (val,val_) => {
        return val === val_;
    }
    const isObject = (val) => {

    }
    const isString = (val) => {
        return typeof val === 'string' || val instanceof String;
    }
    const containSpeacialChar = (val) => {
        if(typeof val === 'undefined' || val === null) return false;
        return val.match(/\W|_/g) ? true : false;
    }
    const containsNumber = (val) => {
        if(typeof val === 'undefined' || val === null) return false;
        return val.match(/\d/) ? true : false;
    }
    const containsLowLetter = (val) => {
        if(typeof val === 'undefined' || val === null) return false;
        return val.match(/[a-z]/) ? true : false;
    }
    const containsCapitalLetter = (val) => {
        if(typeof val === 'undefined' || val === null) return false;
        return val.match(/[A-Z]/) ? true : false;
    }
    const containsCapitalLowLetter = (val) => {
        return containsLowLetter(val) && containsCapitalLetter(val);
    }
    const minLength = (val,length) => {
        return typeof val != 'undefined' && val != null ? val.length >= length : false;
    }
    const validatePassword = (val,val_) => {
        const rules = {
            nePwd : equal(val,val_),
            pwdReqSpecialChar : containSpeacialChar(val),
            pwdReqNumber : containsNumber(val),
            pwdReqAlpha : containsCapitalLowLetter(val),
            pwdReqMin : minLength(val,8)
        };
        return rules;
    }
    const validatePasswordInvalidKey = (val,val_) => {
        const rules = validatePassword(val, val_);
        const rulesKeys = Object.keys(rules);
        let key = true;
        rulesKeys.forEach( key_ => {
            if(rules[key_]===false){
                key = key_;
            }
        });
        return key;
    }
    const validatePasswordState = (val,val_) => {
        const rules = validatePassword(val, val_);
        const rulesKeys = Object.keys(rules);
        let state = true;
        rulesKeys.forEach( key => {
            state = state && rules[key];
        });
        return state;
    }
    const adress = (adress) => {
        if(adress != null && typeof adress != 'undefined'){
            if(typeof adress === 'object'){
                const keys = Object.keys(adress);
                for(let i = 0 ; i<= keys.length - 1 ; i++){
                    if(adress[keys[i]]==null || `${adress[keys[i]]}`.trim()==''){
                        return false;
                    } 
                }
                return true;
            }
        }
        return false;
    }
    app.config.globalProperties.$validator = {
        isNumeric,
        phoneNumber,
        email,
        equal,
        isObject,
        isString,
        containSpeacialChar,
        containsNumber,
        containsLowLetter,
        containsCapitalLetter,
        containsCapitalLowLetter,
        minLength,
        validatePasswordInvalidKey,
        validatePassword,
        validatePasswordState,
        adress
    }
});
